<template>
    <Modal v-model:show="show">
        <div class="align-items-center py-6">
            <div class="modal-body d-flex flex-column align-items-center">
                <div class="send-container">
                        <div class="icon-send-background mb-4">
                            <i class="fas fa-check icon-send"></i>
                        </div>
                        <h2 class="mb-0">{{ $t('emails.verify.activated_account') }}!</h2>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script>

import Modal from '../../argon/components/Modal';

export default {
    name: 'VeryEmailActivated',
    components: {
        Modal,
    },
    data() {
        return {
            show: false,
        };
    },
    mounted() {
        this.show = true;
    },
};
</script>

<style>
.icon-send-background {
    height: 60px;
    width: 60px;
    background-color: #298742;
    border-radius: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
}
.icon-send {
    font-size: 35px;
    color: #fff;
}
.send-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
